import TeacherLandingScreen from './containers/teacherLandingScreen'

export {default as TeacherLandingScreenLayout} from './components/teacherLandingScreenLayout'

export default TeacherLandingScreen
